export const ProjectUserRole = {
  CLIENT: 1,
  TEAM_LEAD: 2,
  LEAD: 3,
  NON_LEAD: 4,
  CLIENT_TEAM_LEAD: 5,
  contains: function (roleId, roles) {
    if (roles.includes(roleId)) {
      return true;
    }
    return false;
  },
  isSpecialist(roleId) {
    return this.contains(roleId, [this.TEAM_LEAD, this.LEAD, this.NON_LEAD]);
  },
  isSpecialistExtended(roleId) {
    return this.contains(roleId, [this.CLIENT_TEAM_LEAD, this.TEAM_LEAD, this.LEAD, this.NON_LEAD]);
  },
  isDraftsman(roleId) {
    return this.contains(roleId, [this.LEAD, this.NON_LEAD]);
  },
  isDecisionMaker(roleId) {
    return this.contains(roleId, [this.CLIENT, this.TEAM_LEAD, this.CLIENT_TEAM_LEAD]);
  },
  isTeamLead(roleId) {
    return this.contains(roleId, [this.TEAM_LEAD, this.CLIENT_TEAM_LEAD]);
  },
  isClient(roleId) {
    return this.contains(roleId, [this.CLIENT, this.CLIENT_TEAM_LEAD]);
  }
}